import { forwardRef, type TextareaHTMLAttributes } from 'react'

import { Field } from '@/components/ui/Field'
import { cn } from '@/lib/utils/cn'

import styles from './Textarea.module.css'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string
  error?: string
  hint?: string
  optional?: boolean
  /** Styles the field as a whole — this is what a form grid positions. */
  className?: string
  textareaClassName?: string
}

/** Multi-line input, in the same field shell as everything else. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, error, hint, optional, id, className, textareaClassName, ...rest },
  ref,
) {
  return (
    <Field
      label={label}
      error={error}
      hint={hint}
      optional={optional}
      id={id}
      className={className}
    >
      {(control) => (
        <textarea
          {...rest}
          {...control}
          ref={ref}
          className={cn(styles.textarea, error && styles.invalid, textareaClassName)}
        />
      )}
    </Field>
  )
})
